import { Grid, Button, Typography } from '@mui/material';
import React from 'react'
// import { useNavigate } from 'react-router-dom';
import Tv404 from './tv404';

const NotFound = () => {
  /*  const [counter, setCounter] = React.useState(8);
 
   const navigate = useNavigate();
 
   const redirect = React.useCallback(() => {
     navigate('/assinar/plano500');
   }, [navigate])
 
   React.useEffect(() => {
     const interval = setInterval(() => {
       setCounter(counter => counter - 1)
     }, 1000)
     return () => clearInterval(interval)
   }, [])
 
   React.useEffect(() => {
     if (counter === 0) {
       redirect();
     }
   }, [counter, redirect]) */

  return (
    <Grid container sx={{
      display: 'flex',
      flexWrap: 'nowrap',
      gap: 1,
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%'
    }}>
      <Tv404 />
      <Typography
        variant="h1"
        textAlign={'center'}
        sx={{ marginBottom: 2, fontSize: '2rem' }}
      >
        <Typography variant='span' sx={{ color: '#FF9F0D', fontWeight: 'bold' }}> Error 404: </Typography>
        Página Não Encontrada
      </Typography>
      <Typography
        variant="h1"
        textAlign={'center'}
        sx={{ marginBottom: 2, fontSize: '1.3rem' }}
      >
        Por favor, verifque a URL e tente novamente...
      </Typography>
      {/*< Typography
        sx={{ marginBottom: 2, fontSize: '1.3rem' }}
      >
        Você será redirecionado em {counter}...
      </Typography>
      <Button
        variant="outlined"
        onClick={() => redirect()}
        sx={{
          borderColor: '#FF9F0D',
          color: '#FF9F0D',
          '&:hover': {
            backgroundColor: '#e68a00',
            color: '#fff',
            borderColor: '#e68a00',
          },
        }}
      >Ou Clique Aqui</Button> */}
    </Grid>
  )
}

export default NotFound
